export const DELIVERY_DRAWER_URL_FRAGMENT_ID = 'delivery-and-returns-info';
export const REVIEWS_DRAWER_URL_FRAGMENT_ID = 'reviews-drawer';
export const REVIEWS_URL_FRAGMENT_ID = 'reviews';

export const getReviewsDrawerURLFragment = (reviewId?: string | null) => {
  return `${REVIEWS_DRAWER_URL_FRAGMENT_ID}${reviewId ? `-${reviewId}` : ''}`;
};

/** The drawer's href, for the list or for one review in full. */
export const getReviewsDrawerHref = (reviewId?: string | null) =>
  `#${getReviewsDrawerURLFragment(reviewId)}`;
